import { config } from '../config'

export const setAppHeader = (headers: any) =>
  setCookie('APP_HEADERS', JSON.stringify(headers), 1);

export const getAppHeaders = () =>
  JSON.parse(getCookie(`APP_HEADERS`) || '{}');

export const setUserEmail = (email: string) =>
  setCookie(`apolloemail${config.env}`, email, 1);

export const getUserEmail = () =>
  getCookie(`apolloemail${config.env}`);

export const setUserToken = (token: string) =>
  setCookie(`apollotoken${config.env}`, token, 1);

export const getUserToken = () =>
  getCookie(`apollotoken${config.env}`)

export const removeUserToken = () => {
  deleteCookie(`apollotoken${config.env}`);
};

export const getGameType = () => {
  switch(config.game) {
    case 'bingo': return 1;
    case 'solitaire': return 2;
    case 'bubble': return 3;
  }
}

const getCookie = (key: string) => {
  let name = key + '='
  let decoded = decodeURIComponent(document.cookie)
  let ca = decoded.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return undefined
}

const setCookie = (key: string, value: string, expireDays: number) => {
  const date = new Date()
  date.setTime(date.getTime() + (expireDays * 24 * 60 * 60 * 1000))
  let expires = 'expires=' + date.toUTCString()
  document.cookie = key + '=' + value + ';' + expires + ';path=/'
}

const deleteCookie = (key: string) => {
  document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
}

export const downloadJSON = (content: any, fileName: string, contentType: string) => {
  const a = document.createElement("a");
  const file = new Blob([content], { type: contentType });
  a.href = URL.createObjectURL(file);
  a.download = fileName;
  a.click();
}